import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Calendar } from "lucide-react";
import { AbsenceRequestForm } from "@/features/rh/conges/components/AbsenceRequestForm";

export const Route = createFileRoute("/_app/rh/conges/create")({
  loader: requirePermission(PERMISSIONS.RH.CONGES.CREATE),
  staticData: {
    title: "Nouvelle demande",
    icon: Calendar,
    permission: PERMISSIONS.RH.CONGES.CREATE,
  },
  component: AbsenceRequestForm,
});
